import { useQuery } from '@tanstack/react-query'
import { UsersRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { EmptyState, ErrorState, LoadingState } from '@/components/feedback/States'
import { Card } from '@/components/ui/Card'
import { PageHeader } from '@/components/ui/PageHeader'
import { familyQuery } from '@/features/portal/api'
import { ReenrollmentCard } from '@/features/promotion/components/ReenrollmentWizard'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

/** Family portal: re-enrolment for next year, one card per child. */
export function FamilyReenrollmentPage() {
  const { t } = useTranslation('promotion')
  useDocumentTitle('Re-enrolment')
  const { data, isPending, error, refetch } = useQuery(familyQuery())
  if (isPending) return <LoadingState />
  if (error) return <ErrorState onRetry={() => void refetch()} />
  return (
    <>
      <PageHeader
        title={t('Re-enrolment')}
        description={t('Tell the school whether each child continues next year, and in which class.')}
      />
      {data.length === 0 ? (
        <Card>
          <EmptyState icon={<UsersRound />} title={t('No student linked to your account')} />
        </Card>
      ) : (
        <div className="grid gap-6 lg:grid-cols-2">
          {data.map((c) => (
            <ReenrollmentCard key={c.student.id} studentId={c.student.id} name={c.student.fullName} />
          ))}
        </div>
      )}
      <p className="mt-6 text-sm text-muted">
        {t('Nothing to answer? Re-enrolment opens when the school starts it for next year.')}
      </p>
    </>
  )
}
